import { createLucideIcon } from 'lucide-react';

export const Android = createLucideIcon('Android', [
  [
    'path',
    {
      key: 'path-1',
      d: 'M5.945 17.75c0 .586.478 1.064 1.066 1.064h1.22v3.014a1.38 1.38 0 0 0 1.366 1.387c.756 0 1.367-.62 1.367-1.387v-3.016h2.128v3.014a1.38 1.38 0 0 0 1.366 1.386c.756 0 1.367-.62 1.367-1.386v-3.014h1.22c.588 0 1.066-.479 1.066-1.064V7.855H5.945zm8.939-15.022L16.008 1.1c.065-.096.05-.223-.038-.286-.087-.06-.212-.03-.277.065l-1.167 1.693a6.9 6.9 0 0 0-2.523-.471c-.9 0-1.755.168-2.524.47L8.313.883c-.065-.094-.19-.127-.278-.064-.088.06-.103.185-.038.285L9.121 2.73c-1.787.831-3.039 2.406-3.199 4.246h12.166c-.165-1.843-1.42-3.417-3.204-4.248m-5.45 2.566a.673.673 0 1 1 0-1.347.673.673 0 0 1 0 1.347m5.217 0a.674.674 0 1 1 0-1.348.674.674 0 0 1 0 1.348m5.593 2.52c-.756 0-1.367.621-1.367 1.387v5.417a1.38 1.38 0 0 0 1.367 1.387c.756 0 1.366-.62 1.366-1.386v-5.42a1.37 1.37 0 0 0-1.366-1.384m-16.487 0c-.756 0-1.367.621-1.367 1.387v5.417a1.38 1.38 0 0 0 1.367 1.387c.756 0 1.367-.62 1.367-1.386v-5.42c0-.766-.614-1.384-1.367-1.384',
      fill: 'currentColor',
      stroke: 'none',
    },
  ],
]);
